import type { TrackEventProperties } from "@/modules/tracking/types"

import { useTracking } from "@/modules/tracking/useTracking"

type CompanyTrackEventProperties = Omit<TrackEventProperties, "service">
type CompanyTrackFunction = (event: string, properties?: CompanyTrackEventProperties) => void

export const useCompanyTrack = (): CompanyTrackFunction => {
  const tracking = useTracking()

  return (event: string, properties: CompanyTrackEventProperties = {}) =>
    tracking?.track(event, { ...properties, service: "company" })
}
